import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      class="design-iconfont"
    >
      <path
        fill={color}
        d="M22.6665625,13.3334375 L22.6665625,10.6671875 C22.6665625,7.0003125 19.66625,4 15.999375,4 C12.333125,4 9.333125,6.9996875 9.333125,10.66625 L9.333125,13.3334375 L5.333125,13.3334375 L5.333125,28 L26.6665625,28 L26.6665625,13.3334375 L22.6665625,13.3334375 L22.6665625,13.3334375 Z M12,10.66625 C12,8.4609375 13.7940625,6.666875 15.999375,6.666875 C18.2053125,6.666875 20,8.4615625 20,10.6675 L20,13.33375 L12,13.33375 L12,10.66625 Z M24,25.3334375 L8,25.3334375 L8,16 L24,16 L24,25.3334375 Z M14.6665625,18.6665625 L17.333125,18.6665625 L17.333125,22.6665625 L14.6665625,22.6665625 L14.6665625,18.6665625 Z"
        fill-rule="nonzero"
      />
    </svg>
  )
}

const LoginByPasswordIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default LoginByPasswordIcon
